import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import authReducer from "./auth/reducer";
import homeReducer from "./home/reducer";
import loanReducer from "./loan/reducer";
import userClientReducer from "./userClient/reducer";
import roleAndPermissionReducer from "./roleAndPermission/reducer";
import userManagementReducer from "./user_management/reducer";
import dashboardReducer from "./dashboard/reducer";
import productReducer from "./product/reducer";
import postReducer from "./post/reducer";
import goldReducer from "./gold/reducer";
import shopReducer from "./shop/reducer";
import transactionReducer from "./transaction/reducer";
import orderReducer from "./order/reducer";
import agencyReducer from "./agency/reducer";
import categoryReducer from "./category/reducer";
import pageSettingReducer from "./pageSetting/reducer";
import accumulationReducer from "./accumulation/reducer";
import imageProductReducer from "./image_product/reducer";
import settingReducer from "./setting/reducer";
import nfcReducer from "./nfc/reducer";
import videoReducer from "./video_post/reducer";
import merchantReducer from "./merchant/reducer";
import marketingReducer from "./marketing/reducer";
import partnerReducer from "./partner/reducer";
import merchantHNGReducer from "./merchant_hng/reducer";
import businessVoucherReducer from "./business_voucher/reducer";
import priorityReducer from "./priority/reducer";

export const rootReducer = combineReducers({
  loanReducer,
  auth: auth.reducer,
  authReducer: authReducer,
  homeReducer: homeReducer,
  categoryReducer: categoryReducer,
  userClientReducer,
  roleAndPermissionReducer,
  userManagementReducer,
  dashboardReducer,
  productReducer,
  postReducer,
  goldReducer,
  shopReducer,
  transactionReducer,
  orderReducer,
  pageSettingReducer,
  agencyReducer,
  accumulationReducer,
  imageProductReducer,
  settingReducer,
  nfcReducer,
  videoReducer,
  merchantReducer,
  marketingReducer,
  partnerReducer,
  merchantHNGReducer,
  businessVoucherReducer,
  priorityReducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
